document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.casino-card-mini__link').forEach((element, index) => {
    if (element) element.dataset.position = index + 1;
  });

  document.querySelectorAll('.probrand-card__btn--stretched').forEach((element, index) => {
    if (element) element.dataset.position = index + 1;
  });

  const setToplistCardPosition = () => {
    document.querySelectorAll('.toplist-grid,.cg-slider').forEach((element) => {
      if (!element) return;

      element.querySelectorAll('.toplist-card').forEach((card, index) => {
        const links = [
          card.querySelector('.toplist-card__thumbnail a'),
          card.querySelector('.toplist-card__recension-btn'),
          card.querySelector('.toplist-card__recension a'),
          card.querySelector('.toplist-card__actions a[rel="nofollow noindex"]')
        ];

        links.forEach((link) => {
          if (link) {
            link.dataset.position = index + 1;
          }
        });
      });
    });
  };
  setToplistCardPosition();

  const setSlotsCardPosition = () => {
    document.querySelectorAll('.wp-block-group,.article-list-archive').forEach((element) => {
      if (!element) return;

      element.querySelectorAll('.slot-card').forEach((card, index) => {
        const link = card.querySelector('a.button');

        if (link) {
          link.dataset.position = index + 1;
        }
      });
    });
  };
  setSlotsCardPosition();

  document.addEventListener('loadMoreTriggered', (e) => {
    const { type } = e.detail;

    switch (type) {
      case 'toplist':
        setToplistCardPosition();
        break;
      case 'slots':
        setSlotsCardPosition();
        break;
    }
  });
});
